export default "__VITE_ASSET__f91aed02__"